// Full service catalogue — Services Provided
export const SERVICES = [
  {
    id: '01',
    title: 'Engineering',
    summary:
      'Structural analysis and modification engineering for towers, mounts, foundations, and elevated platforms.',
    image: '/images/services/engineering.png',
    list: [
      'Structural Analysis (Tower & Mount)',
      'Structural Modification Design/Drawings',
      'Rooftop/Water Tank Analysis',
      'Structural Letters',
      'Foundation Designs',
      'Utility Pole Analysis',
      'TIA Inspection Reports',
      'PMI/Quality Reports',
      'Qualified Engineering Review',
    ],
  },
  {
    id: '02',
    title: 'Site Development',
    summary:
      'Complete A&E and detailing packages that take sites from concept to construction-ready.',
    image: '/images/services/siteDevelopment.png',
    list: [
      'A&E Drawings',
      'As-Built Drawings',
      'Structural Detailing',
      'Small Cell Node Design',
      'Fiber Route Drawings',
      'Generator Drawings',
      'In-Building / DAS',
      'Revit/Architectural Drawings',
      'PV System Design & Engineering (Solar)',
      'Electrical Design',
    ],
  },
  {
    id: '03',
    title: 'Project Management',
    summary:
      'Schedule control, delivery tracking, and documentation from kickoff to closeout.',
    image: '/images/services/projectManagement.png',
    list: [
      'Job Setups',
      'Project Scheduling',
      'Preparing Work Logs',
      'Project Controls',
      'Invoicing',
    ],
  },
  {
    id: '04',
    title: 'Site Acquisition',
    summary:
      'Zoning, permitting, and jurisdictional reporting that keep projects moving.',
    image: '/images/services/siteAcquisition.png',
    list: [
      'Desktop Audit & SCIP',
      'Preliminary Zoning & Permitting Determination',
      'Zoning Administrative Reviews',
      'Permitting',
      'Utility Coordination',
      'Report Writing For Jurisdictions/Contractors',
    ],
  },
  {
    id: '05',
    title: 'RF Engineering',
    summary:
      'RF testing, optimization, and DAS deployments for reliable wireless coverage.',
    image: '/images/services/rfEngineering.png',
    list: [
      'RF Testing And Optimization',
      'DAS (Distributed Antenna System) Deployments',
    ],
  },
  {
    id: '06',
    title: 'Administrative Support',
    summary:
      'Back-office support spanning accounting, contracts, legal, controls, and HR.',
    image: '/images/services/administrative.png',
    list: [
      'Accounting',
      'Contracts Management',
      'Legal & Compliance',
      'HR Management',
    ],
  },
];

export const getServiceByTitle = (title) => {
  return SERVICES.find((service) => service.title === title) || null;
};

export const getServiceTitles = () => {
  return SERVICES.map((service) => service.title);
};

export const getTotalServices = () => {
  return SERVICES.length;
};

export const getServiceItemCount = (title) => {
  const service = getServiceByTitle(title);
  return service ? service.list.length : 0;
};
